import { ListModalitiesDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteListModalitiesDiagnosisReport
  implements ListModalitiesDiagnosisReport
{
  private readonly url: string;

  private readonly httpClient: HttpClient<ListModalitiesDiagnosisReport.Model>;

  constructor(
    url: string,
    httClient: HttpClient<ListModalitiesDiagnosisReport.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  listModalities = async (
    params: ListModalitiesDiagnosisReport.Params,
  ): Promise<ListModalitiesDiagnosisReport.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
